import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { ToggleSwitch } from '@retail/components';

interface Props {
  toggleVat: boolean;
  justifyContent?: 'space-between' | 'inherit';
  handleToggleVat: () => void;
  label?: string;
}

export const ExcludeVatSwitch = ({
  toggleVat,
  justifyContent = 'inherit',
  handleToggleVat,
  label,
}: Props) => {
  const t = useMyAssortmentTFunction();
  return (
    <ToggleSwitch
      toggle={toggleVat}
      setToggle={handleToggleVat}
      justifyContent={justifyContent}
      text={label ?? t('myAssortment.actions.includeVat')}
    />
  );
};
